import styled from 'styled-components';

const KeyIndicatorsCardContainer = styled.div`
  .tableContainer {
    width: calc(100vw - 170px);
  }

  .starCountContainer {
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .titleRight {
    padding-bottom: 2px;
  }
`;

const HeaderRightComponents = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props: any) => props.theme.fonts.sfcompact_text};

  .linkContainer {
    display: flex;
    text-decoration: none;
  }

  .prepareMyTrip {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
    text-decoration: none;

    p {
      display: none;
    }

    :hover {
      p {
        display: block;
      }
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    margin-top: 10px;
    margin-left: 0;
  }

  .labelCheckbox {
    margin-right: 5px;
    margin-left: 10px;
    font-size: 12px;
    font-family: ${(props: any) => props.theme.fonts.sfcompact_text};
    color: ${(props: any) => props.theme.colors['dark-two']};
  }

  .localisationIcon {
    margin-left: 10px;
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .containerCheckShowWines {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 10px;

    p {
      margin-left: 5px;
      font-family: ${(props: any) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
    }
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  @media (max-width: ${(props: any) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-family: ${(props: any) => props.theme.fonts.oswald};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #202529;
    text-transform: uppercase;
  }

  .keyIndicatorsIcon {
    margin-left: 10px;
  }

  .leftText {
    margin-left: 32px;
    margin-right: 32px;
    opacity: 0.5;
    font-family: ${(props: any) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    max-width: 66%;
    white-space: normal;
    color: #1e3647;

    p {
      white-space: pre-wrap;
    }
  }

  .titleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: ${(props: any) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    white-space: normal;
  }
`;

export { Title, KeyIndicatorsCardContainer, HeaderRightComponents };
